module.exports = ".check{\r\n    padding:20px;\r\n}"


//////////////////
// WEBPACK FOOTER
// ./src/app/othertransaction/sb-intrest-calculation/sb-intrest-calculation.component.css
// module id = ./src/app/othertransaction/sb-intrest-calculation/sb-intrest-calculation.component.css
// module chunks = main